import { render } from "./PageFeedback.vue?vue&type=template&id=408b0b82"
import script from "./PageFeedback.vue?vue&type=script&lang=js"
export * from "./PageFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__